import Grid from '@mui/material/Grid';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EditAccountingParameterForm } from '../../types';
import { TextFieldFormInput, useFlexSalesForm } from '../FlexSalesForm';

const inputPropsReadOnly = { readOnly: true };
const inputPropsLength25 = { maxLength: 25 };
const inputPropsLength40 = { maxLength: 40 };

const detailsKey: keyof EditAccountingParameterForm = 'details';

const DetailsFormInputArray = () => {
  const { t } = useTranslation();
  const { control } = useFlexSalesForm();
  const { fields } = useFieldArray({
    control,
    name: detailsKey,
  });

  return (
    <>
      {fields.map((item, index) => (
        <Grid item xs key={item.id}>
          <TextFieldFormInput
            name={`${detailsKey}.${index}.tender_wh`}
            type="hidden"
            variant="standard"
          />
          <Grid container flexDirection="row" spacing={1}>
            <Grid item xs>
              <TextFieldFormInput
                name={`${detailsKey}.${index}.journalSubtype`}
                type="text"
                variant="standard"
                label={t('accountingParameters.columns.journalSubType')}
                inputProps={inputPropsReadOnly}
                fullWidth
              />
            </Grid>
            <Grid item xs>
              <TextFieldFormInput
                name={`${detailsKey}.${index}.subtype_description`}
                type="text"
                variant="standard"
                label={t('accountingParameters.columns.subtype_description')}
                inputProps={inputPropsLength40}
                fullWidth
              />
            </Grid>
            <Grid item xs>
              <TextFieldFormInput
                name={`${detailsKey}.${index}.account`}
                type="text"
                variant="standard"
                label={t('accountingParameters.columns.account')}
                required
                inputProps={inputPropsLength25}
                fullWidth
              />
            </Grid>
            <Grid item xs>
              <TextFieldFormInput
                name={`${detailsKey}.${index}.subAccount`}
                type="text"
                variant="standard"
                label={t('accountingParameters.columns.subAccount')}
                required
                inputProps={inputPropsLength25}
                fullWidth
              />
            </Grid>
            <Grid item xs>
              <TextFieldFormInput
                name={`${detailsKey}.${index}.project`}
                type="text"
                variant="standard"
                label={t('accountingParameters.columns.project')}
                inputProps={inputPropsLength25}
                fullWidth
              />
            </Grid>
            <Grid item xs>
              <TextFieldFormInput
                name={`${detailsKey}.${index}.segment7`}
                type="text"
                variant="standard"
                label={t('accountingParameters.columns.segment7')}
                inputProps={inputPropsLength25}
                fullWidth
              />
            </Grid>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default DetailsFormInputArray;
